(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('composite', {
            parent: 'entity',
            url: '/composite',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Composites'
            },
            ncyBreadcrumb: {
                label: 'Composite',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/composite/composites.html',
                    controller: 'CompositeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('composite-detail', {
            parent: 'entity',
            url: '/composite/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Composite'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/composite/composite-detail.html',
                    controller: 'CompositeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Composite', function($stateParams, Composite) {
                    return Composite.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'composite',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('composite-detail.edit', {
            parent: 'composite-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/composite/composite-dialog.html',
                    controller: 'CompositeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Composite', function(Composite) {
                            return Composite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('composite.new', {
            parent: 'composite',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/composite/composite-dialog.html',
                    controller: 'CompositeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dialysisModality: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('composite', null, { reload: 'composite' });
                }, function() {
                    $state.go('composite');
                });
            }]
        })
        .state('composite.edit', {
            parent: 'composite',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/composite/composite-dialog.html',
                    controller: 'CompositeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Composite', function(Composite) {
                            return Composite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('composite', null, { reload: 'composite' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('composite.delete', {
            parent: 'composite',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/composite/composite-delete-dialog.html',
                    controller: 'CompositeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Composite', function(Composite) {
                            return Composite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('composite', null, { reload: 'composite' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
